"use strict";

var get = require('lodash.get');
var isAdmin = function isAdmin(viewer) {
  return get(viewer, 'roles.admin') === true;
};
var isEditor = function isEditor(viewer) {
  return get(viewer, 'roles.editor') === true;
};
var isViewer = function isViewer(viewer) {
  return !!get(viewer, 'id');
};
var isOrganisationAdmin = function isOrganisationAdmin(viewer) {
  var roles = get(viewer, 'roles') || {};
  var organisationId = get(viewer, 'organisationId');
  return roles["organisationAdmin_".concat(organisationId)] === true;
};
var hasPermission = function hasPermission(roles, viewer) {
  var hasAdminPermission = roles.includes('ADMIN') && isAdmin(viewer);
  var hasOrgAdminPermission = roles.includes('ORGANISATION_ADMIN') && isOrganisationAdmin(viewer);
  var hasEditorPermission = roles.includes('EDITOR') && isEditor(viewer);
  var hasViewerPermission = roles.includes('VIEWER') && isViewer(viewer);
  return hasAdminPermission || hasOrgAdminPermission || hasEditorPermission || hasViewerPermission;
};
var makeAuthorize = function makeAuthorize(_ref) {
  var ORGS_NAMESPACE = _ref.ORGS_NAMESPACE,
    ROLES_NAMESPACE = _ref.ROLES_NAMESPACE,
    getDecodedToken = _ref.getDecodedToken;
  return function (options) {
    console.warn('Authorized call is being deprecated. Please move to authenticate.');
    var allowRoles = get(options, 'allowRoles') || [];
    var skipCache = !!get(options, 'skipCache');
    return getDecodedToken({
      refetch: skipCache
    }).then(function (decoded) {
      var viewer = {
        id: get(decoded, 'sub'),
        organisationId: get(decoded, ORGS_NAMESPACE),
        roles: get(decoded, ROLES_NAMESPACE)
      };
      return {
        isAuthorized: hasPermission(allowRoles, viewer),
        isAuthenticated: !!get(decoded, 'sub')
      };
    }).catch(function (err) {
      return {
        isAuthenticated: false,
        isAuthorized: false,
        error: err
      };
    });
  };
};
module.exports = {
  makeAuthorize: makeAuthorize
};